export default "__VITE_ASSET__5rucZNB9__"